import type { DateOnly } from '@/types/schemas';
import { daysBetween, formatDate } from '@/utils/date';

import type { Prospect } from '../schemas/prospect.schema';

export type FollowUpUrgency = 'overdue' | 'today' | 'soon' | 'later' | 'none';

/** How pressing a follow-up is. Closed enquiries (converted, lost) never are. */
export function followUpUrgency(prospect: Prospect, today: DateOnly): FollowUpUrgency {
  if (!prospect.followUpDate) return 'none';
  if (prospect.status === 'converted' || prospect.status === 'lost') return 'none';
  const days = daysBetween(today, prospect.followUpDate);
  if (days < 0) return 'overdue';
  if (days === 0) return 'today';
  if (days <= 2) return 'soon';
  return 'later';
}

/** "Today", "Tomorrow", "Overdue · 22 Sep 2026" or the date. */
export function followUpLabel(prospect: Prospect, today: DateOnly): string | null {
  if (!prospect.followUpDate) return null;
  const urgency = followUpUrgency(prospect, today);
  if (urgency === 'today') return 'Today';
  if (urgency === 'overdue') return `Overdue · ${formatDate(prospect.followUpDate)}`;
  if (daysBetween(today, prospect.followUpDate) === 1) return 'Tomorrow';
  return formatDate(prospect.followUpDate);
}
